import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import * as creditCardType from 'credit-card-type';
import { CreditCard } from '../models/credit-card.model';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.scss']
})
export class CreditCardComponent implements OnInit {

  cards: Array<CreditCard> = [];
  isLoggedIn = false;
  showCardForm = false;
  saving = false;
  error = false;

  @Input() card: CreditCard;
  @Input() type: string; // checkout, add-card
  @Output() formSubmit: EventEmitter<any> = new EventEmitter();

  @ViewChild('numberInputEl') numberInputEl: ElementRef;
  @ViewChild('cvvInputEl') cvvInputEl: ElementRef;
  @ViewChild('yearInputEl') yearInputEl: ElementRef;
  @ViewChild('monthInputEl') monthInputEl: ElementRef;
  @ViewChild('holderInputEl') holderInputEl: ElementRef;

  constructor(
    private auth: AuthService
  ) { }

  ngOnInit() {
    if (this.auth.accessData.value) {
      this.isLoggedIn = true;
      this.getCreditCards();
    }
  }

  getCreditCards() {
    this.auth.getCreditCards().subscribe((c: Array<CreditCard>) => { this.cards = c; });
  }

  onSubmit(form) {
    this.error = false;
    if (this.type === 'add-card') {
      this.saving = true;
      this.auth.saveCreditCard(this.card).subscribe((success) => {
        // credit card added
        this.saving = false;
        this.getCreditCards();
        this.card = new CreditCard();
        this.showCardForm = false;
      }, (err) => {
        this.saving = false;
        this.error = true;
      });
    } else {
      this.formSubmit.emit();
    }
  }

  onChangeCardNumber() {
    const number = this.card.cardNumber;
    const start = number.substring(0, 2);
    if ((start === '34' || start === '37') && number.length === 17) {
      // amex
      this.getCCType(number);
      this.monthInputEl.nativeElement.focus();
    } else if (number.length === 19) {
      this.getCCType(number);
      this.monthInputEl.nativeElement.focus();
    } else {
      this.formatCCNumber(number);
    }
  }

  onChangeExpiryMonth() {
    if (this.card.expiryMonth.length === 2) {
      this.yearInputEl.nativeElement.focus();
    }
  }

  onChangeExpiryYear() {
    if (this.card.expiryYear.length === 2) {
      this.cvvInputEl.nativeElement.focus();
    }
  }

  onChangeCardSecurityCode() {
    // nothing
  }

  getCCType(number) {
    const type = creditCardType(number.replace(/\s/g, ''));
    this.card.cardType = type[0].niceType;
  }

  formatCCNumber(number) {
    const amexRegex = /^3[47][0-9]{5,}$/;
    const start = number.substring(0, 2);
    if (start === '34' || start === '37') {
      // potential amex card
      const formatted = number.replace(/[^\dA-Z]/g, '').replace(/(.{4})/, '$1 ').replace(/(.{11})/, '$1 ').replace(/(.{17})/, '$1 ').trim();
      if (formatted !== number) {
        this.card.cardNumber = formatted;
      }
    } else if (number && number.length < 20) {
      const formatted = number.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
      if (formatted !== number) {
        this.card.cardNumber = formatted;
      }
    }
  }

  toggleCardForm() {
    this.showCardForm = !this.showCardForm;
  }

  deleteCard(card: CreditCard) {
    this.auth.deleteCreditCard(card.innoCardPaymentId).subscribe(
      (success) => {
        this.cards.splice(this.cards.indexOf(card), 1);
      }
    );
  }
}
